import React from "react";
const urlApi = process.env.REACT_APP_STRAPI_URL;
export default function BeneficiosComex({ icon, titulo, subtitulo }) {
  return (
    <div
      data-testid="beneficioscomex-section"
      className=" h-[400px] mt-[30px] flex flex-col w-full md:flex-row gap-10 justify-center "
    >
      <div className="group flex-1 p-8 flex flex-col items-center text-center min-w-[260px] rounded-xl dark:border dark:border-sidom-orange bg-sidom-blue hover:bg-sidom-orange hover:text-sidom-light cursor-pointer transition-colors duration-200">
        <div className=" rounded-full   flex items-center justify-center mb-4">
          <img
            src={`${urlApi}${icon}`}
            alt={titulo}
            className="w-20 h-20 object-contain rounded-full "
          />
        </div>
        <h1 className="text-xl text-sidom-orange font-bold mb-2 group-hover:text-sidom-light">
          {titulo}
        </h1>
        <p className="text-sidom-light text-base">{subtitulo}</p>
      </div>
    </div>
  );
}
